import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Shift',
  icon: 'mdi-update',
  path: '/reports/mcd/shift/',
  children: [
    {
      path: '/reports/mcd/shift/AOT',
      name: 'AOT Dashboard',
      meta: { id: 'reports-aot' },
      component: () => import('./aot/aot.vue'),
      ...addPermissionsToRoute(['aot']),
      tags: ['aot'],
    },
    {
      path: '/reports/mcd/shift/dailyActivity',
      name: 'Daily Activity Report',
      meta: { id: 'reports-dar' },
      component: () => import('./dailyActivityReport.vue'),
      ...addPermissionsToRoute(['dar']),
      tags: ['dar'],
    },
    {
      path: '/reports/mcd/shift/3DTrend',
      name: '3D Trend',
      meta: { id: 'reports-3dTrend' },
      component: () => import('./threeDTrend.vue'),
      ...addPermissionsToRoute(['3dTrend']),
    },
    {
      path: '/reports/mcd/shift/3PeaksReport',
      name: '3 Peaks',
      meta: { id: 'reports-threePeak' },
      component: () => import('./threePeaks/threePeaks.vue'),
      ...addPermissionsToRoute(['threePeak']),
    },
    {
      path: '/reports/mcd/shift/rank',
      name: 'Rank',
      meta: { id: 'reports-rank' },
      component: () => import('./rank/rank.vue'),
      ...addPermissionsToRoute(['rank']),
    },
    {
      path: '/reports/mcd/shift/trends',
      name: 'Trends',
      meta: { id: 'reports-trends' },
      component: () => import('./trends/trends.vue'),
      ...addPermissionsToRoute(['trend']),
    },
    {
      path: '/reports/mcd/shift/focusOnService',
      name: 'Focus On Service',
      meta: { id: 'reports-focusOnService' },
      component: () => import('./focusOnService.vue'),
      ...addPermissionsToRoute(['focusOnService']),
    },
    {
      path: '/reports/mcd/shift/operationsReport',
      name: 'Operations Report',
      meta: { id: 'reports-operationsReport' },
      component: () => import('./ops/operationsReport.vue'),
      ...addPermissionsToRoute(['operationsReport']),
      tags: ['ops'],
    },
    {
      path: '/reports/mcd/shift/shiftManagerSummary',
      name: 'Shift Manager Summary',
      meta: { id: 'reports-shiftManagerSummary' },
      component: () => import('./shiftManagerSummary.vue'),
      ...addPermissionsToRoute(['shiftManagerSummary']),
    },
    {
      path: '/reports/mcd/shift/peakTargetAndTracking',
      name: 'Peak Target and Tracking',
      meta: { id: 'reports-peakTargetAndTracking' },
      component: () => import('./peakTargetAndTracking.vue'),
      ...addPermissionsToRoute(['peakTargetAndTracking']),
    },
    {
      path: '/reports/mcd/shift/findMyPeak',
      name: 'Find My Peak',
      meta: { id: 'reports-findMyPeak' },
      component: () => import('./findMyPeak/findMyPeak.vue'),
      ...addPermissionsToRoute(['mobileAppSummary', 'serviceTimesStatistics']),
    },
    {
      path: '/reports/mcd/shift/timeSliceSummary',
      name: 'Time Slice Summary',
      meta: { id: 'reports-timeSliceSummary' },
      component: () => import('./timeSliceSummary/timeSliceSummary.vue'),
      ...addPermissionsToRoute(['timeSliceSummary']),
    },
    {
      path: '/reports/mcd/shift/dailyGlimpse',
      name: 'Daily Glimpse',
      meta: { id: 'reports-dailyGlimpse' },
      component: () => import('./dailyGlimpse.vue'),
      ...addPermissionsToRoute(['dailyGlimpse']),
    },
    {
      path: '/reports/mcd/shift/operationsByPunched',
      name: 'Punched Summary',
      meta: { id: 'reports-operationsByPunched' },
      component: () => import('./operationsByPunched.vue'),
      ...addPermissionsToRoute(['operationsByPunched']),
    },
    {
      path: '/reports/mcd/shift/operationMetricRecords',
      name: 'Records',
      meta: { id: 'reports-operationMetricRecords' },
      component: () => import('./operationMetricRecords.vue'),
      ...addPermissionsToRoute(['operationMetricRecords']),
    }
  ]
};

export default routes;